
import React, { useEffect, useState } from "react";
import s from "../Lesson.module.css";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import { useAppTranslation } from "./TranslationContext";
import { getThemes } from '../services/themesCache';

export const Lesson = () => {
  const { user, handleLang } = useAuth();
  const { t } = useAppTranslation();
  const { userKursData, setUserKursData } = useAuth();
  const { kursId, id } = useParams();
  const navigate = useNavigate();
  let localUser = JSON.parse(localStorage.getItem('user'));

  const [dataThemes, setThemes] = useState([]);
  const [lessonData, setLessonData] = useState(null);
  const [prevLesson, setPrevLesson] = useState(null);
  const [nextLesson, setNextLesson] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  /* user-kurs */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://api.aiassessment.uz/api/user-kurs/');
        if (!response.ok) throw new Error('Ошибка при загрузке данных');
        const data = await response.json();
        const foundItem = data.find(item =>
          (parseInt(item.kurs) === parseInt(kursId)) && (parseInt(item.user) === parseInt(localUser.id))
        );
        setUserKursData({ id: foundItem.id, mavzu: foundItem.mavzu });
      } catch (error) {
        console.error('Произошла ошибка:', error);
      }
    };
    fetchData();
  }, []);

  /* themes list */
  useEffect(() => {
    const fetchThemes = async () => {
      try {
        const data = await getThemes(kursId);
        setThemes([...data].sort((a, b) => a.tartib - b.tartib));
      } catch (err) {
        console.error(err);
      }
    };
    fetchThemes();
  }, [kursId]);

  /* lesson data */
  useEffect(() => {
    const fetchLesson = async () => {
      try {
        const res = await fetch(`https://api.aiassessment.uz/api/kurs-mavzulari/${id}/`);
        if (!res.ok) throw new Error("Ошибка при загрузке урока");
        const data = await res.json();
        setLessonData({
          id: data.id,
          tartib: data.tartib,
          kurs_id: parseInt(kursId),
          title_uz: data.nomi_uz,
          title_ru: data.nomi_ru,
          title_en: data.nomi_en,
          videolink_uz: data.videolink_uz,
          videolink_ru: data.videolink_ru,
          videolink_en: data.videolink_en,
          text_uz: data.maruza_matn_uz,
          text_ru: data.maruza_matn_ru,
          text_en: data.maruza_matn_en,
          file_uz: data.maruza_file_uz,
          file_ru: data.maruza_file_ru,
          file_en: data.maruza_file_en,
          test_soni: data.test_soni,
          test_min: data.test_min_soni,
          test_description_uz: data.test_description_uz,
          test_description_ru: data.test_description_ru,
          test_description_en: data.test_description_en,
        });
      } catch (err) {
        console.error(err);
      }
    };
    fetchLesson();
  }, [id, kursId]);

  /* prev / next */
  useEffect(() => {
    if (!dataThemes.length || !lessonData) return;
    let prev = null, next = null;
    dataThemes.forEach(item => {
      if (item.tartib === lessonData.tartib - 1) prev = item;
      if (item.tartib === lessonData.tartib + 1) next = item;
    });
    setPrevLesson(prev);
    setNextLesson(next);
  }, [dataThemes, lessonData]);

  /* navigation */
  const goToPreviousLesson = () => {
    if (prevLesson) navigate(`/Lesson/${kursId}/${prevLesson.id}`);
  };

  const goToNextLesson = () => {
    if (!userKursData) return;
    const allowedIndex = userKursData.mavzu;
    if (nextLesson && nextLesson.tartib <= allowedIndex) {
      navigate(`/Lesson/${kursId}/${nextLesson.id}`);
    }
  };

  /* drawer */
  const openModal = () => {
    setIsOpen(true);
    setTimeout(() => setIsVisible(true), 10);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsVisible(false);
    setTimeout(() => {
      setIsOpen(false);
      document.body.style.overflow = 'auto';
    }, 400);
  };

  const onOverlayClick = (e) => {
    if (e.target === e.currentTarget) closeModal();
  };

  if (!lessonData) return (
    <div className={s.page}>
      <div className={s.loadingPage}>Yuklanmoqda...</div>
    </div>
  );

  const videoUrl = handleLang(lessonData.videolink_uz, lessonData.videolink_ru, lessonData.videolink_en);
  const textContent = handleLang(lessonData.text_uz, lessonData.text_ru, lessonData.text_en);
  const files = [
    { url: lessonData.file_uz, label: 'Qo\'shimcha materiallar 1' },
    { url: lessonData.file_ru, label: 'Qo\'shimcha materiallar 2' },
    { url: lessonData.file_en, label: 'Qo\'shimcha materiallar 3' },
  ].filter(f => f.url);

  return (
    <div className={s.page}>

      {/* ── Drawer overlay ── */}
      {isOpen && (
        <div
          className={`${s.overlay} ${isVisible ? s.overlayVisible : ''}`}
          onClick={onOverlayClick}
        >
          <div className={s.drawer}>
            <div className={s.drawerHeader}>
              <span className={s.drawerTitle}>{t('contents')}</span>
              <button className={s.drawerClose} onClick={closeModal}>&times;</button>
            </div>
            <ul className={s.drawerList}>
              {dataThemes.map((item, index) => {
                const allowedIndex = userKursData?.mavzu || 0;
                const isLocked = item.tartib > allowedIndex;
                const isActive = item.id === parseInt(id);
                return isLocked ? (
                  <span key={index} className={`${s.drawerItem} ${s.drawerItemLocked}`}>
                    {handleLang(item.nomi_uz, item.nomi_ru, item.nomi_en)}
                  </span>
                ) : (
                  <Link
                    to={`/Lesson/${kursId}/${item.id}`}
                    key={index}
                    className={`${s.drawerItem} ${isActive ? s.drawerItemActive : ''}`}
                    onClick={closeModal}
                  >
                    {handleLang(item.nomi_uz, item.nomi_ru, item.nomi_en)}
                  </Link>
                );
              })}
            </ul>
          </div>
        </div>
      )}

      {/* ── Top bar ── */}
      <div className={s.topBar}>
        <span className={s.topBarTitle}>
          {handleLang(lessonData.title_uz, lessonData.title_ru, lessonData.title_en)}
        </span>

        <div className={s.topBarControls}>

          {/* Contents button */}
          <button className={s.iconBtn} onClick={openModal} title={t('contents')}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
              <g>
                <path d="M27 10H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V13a3 3 0 0 0-3-3zm1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1zm-7.55-7.89-8-4A1 1 0 0 0 11 16v8a1 1 0 0 0 .47.85A1 1 0 0 0 12 25a1 1 0 0 0 .45-.11l8-4a1 1 0 0 0 0-1.78zM13 22.38v-4.76L17.76 20zM7 3a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1zM4 7a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1z" />
              </g>
            </svg>
          </button>

          {/* Previous lesson */}
          <button className={s.iconBtn} onClick={goToPreviousLesson} disabled={!prevLesson} title="Предыдущий урок">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{ transform: 'rotate(180deg)' }}>
              <g>
                <path d="m22.707 11.293-7-7a1 1 0 0 0-1.414 1.414L19.586 11H2a1 1 0 0 0 0 2h17.586l-5.293 5.293a1 1 0 1 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414z" />
              </g>
            </svg>
          </button>

          {/* Next lesson */}
          <button className={s.iconBtn} onClick={goToNextLesson} disabled={!nextLesson} title="Следующий урок">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <g>
                <path d="m22.707 11.293-7-7a1 1 0 0 0-1.414 1.414L19.586 11H2a1 1 0 0 0 0 2h17.586l-5.293 5.293a1 1 0 1 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414z" />
              </g>
            </svg>
          </button>

        </div>
      </div>

      {/* ── Main content ── */}
      <div className={s.main}>

        {/* Video */}
        {videoUrl && (
          <div className={s.videoWrap}>
            <iframe
              className={s.video}
              src={videoUrl}
              title="Video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        )}

        {/* Text */}
        {textContent && (
          <div
            className={s.textSection}
            dangerouslySetInnerHTML={{ __html: textContent }}
          />
        )}

        {/* Materials */}
        {files.length > 0 && (
          <div className={s.materialsSection}>
            <span className={s.sectionLabel}>{t('materials')}</span>
            {files.map((f) => (
              <a key={f.url} href={f.url} target="_blank" rel="noreferrer" download className={s.fileCard}>
                <div className={s.fileCardLeft}>
                  <div className={s.fileIcon}>
                    <svg viewBox="0 0 24 24" width="20" height="20">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" fill="#555" />
                    </svg>
                  </div>
                  <span className={s.fileName}>{f.label}</span>
                </div>
                <div className={s.fileDownloadIcon}>
                  <svg viewBox="0 0 24 24" width="16" height="16">
                    <path d="M21 19H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2zM12 2a1 1 0 0 0-1 1v10.59l-3.29-3.3a1 1 0 0 0-1.42 1.42l5 5a1 1 0 0 0 1.42 0l5-5a1 1 0 0 0-1.42-1.42L13 13.59V3a1 1 0 0 0-1-1z" />
                  </svg>
                </div>
              </a>
            ))}
          </div>
        )}

        {/* Bottom navigation */}
        <div className={s.bottomNav}>
          <Link to={`/themes/${kursId}/`} className={s.btnBack}>
            {t('testBack')}
          </Link>

          {dataThemes.length > 0 && (
            <Link
              to={`/test/${kursId}/${id}/${dataThemes.length}/${nextLesson?.id}/`}
              className={s.btnTest}
            >
              <span className={s.btnTestText}>{t('test')}</span>
            </Link>
          )}
        </div>

      </div>
    </div>
  );
};
